import React from 'react';
export function Logo({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`flex items-center gap-2.5 ${className}`} data-id="element-743" data-mp="8t38fup2g0v2">
      <svg viewBox="0 0 34 34" className="h-7 w-7 shrink-0 text-ember lg:h-8 lg:w-8" aria-hidden="true" fill="none" data-id="element-744" data-mp="8ueb1r6rz2kl">
        <circle cx="17" cy="17" r="16" stroke="currentColor" strokeOpacity="0.35" strokeWidth="1.5" data-id="element-745" data-mp="3q7qghlhvfcit" />
        <path d="M17 6c4.2 4 6.3 7.3 6.3 10.6a6.3 6.3 0 1 1-12.6 0C10.7 13.3 12.8 10 17 6Z" fill="currentColor" data-id="element-746" data-mp="3v6bede9nhk43" />
      </svg>
      <span className="leading-none" data-id="element-747" data-mp="rsh4qja9pnoq">
        <span className="block font-display text-sm font-semibold tracking-tight text-chalk lg:text-[15px]" data-id="element-748" data-mp="rrfgfd48r4p2">
          Daily Car Care
        </span>
        <span className="mt-1 hidden text-[10px] uppercase tracking-[0.28em] text-dim sm:block" data-id="element-749" data-mp="hthskqqan9wz">
          Detailingstudio
        </span>
      </span>
    </span>;
}